// removed by extract-text-webpack-plugin
module.exports = {"seo":"seo___6YlIP","container":"container___-wbh5","column":"column___3W0iy","wrapper":"wrapper___utffE","column-title":"column-title___2jMBP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Seo/Seo.scss
// module id = 6Ojs
// module chunks = 46